import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Button,
  FormGroup,
  Form,
  Input,
  Spinner,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

import s from "./Tables.module.scss";

import { API_TIMEOUT, LOKASI, EXPIRED } from "../../utils/index.js";
import axios from "axios";

import { numberWithCommas, logApp } from "../../utils/func.js";
import Select from "react-select";
import swal from "sweetalert";

// Fungsi untuk format tanggal Indonesia
const formatTanggalIndonesia = (dateString) => {
  if (!dateString) return "-";
  try {
    // Handle format ISO datetime (2025-12-30T16:00:00.000Z) atau format date (2025-12-30)
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "-";
    }
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("id-ID", options);
  } catch (error) {
    return "-";
  }
};

const TableExpired = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [bulan, setBulan] = useState(3); // Default 3 bulan
  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [userLevel, setUserLevel] = useState("");
  const [userStatus, setUserStatus] = useState("");

  useEffect(() => {
    if (!currentUser) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        setCurrentUser(user);
        setIdLokasi(user.idLokasi);
        setUserStatus(user.status);
        logApp(user.uid, "Data Expired");
      }
    }
  }, []);

  useEffect(() => {
    if (idLokasi) {
      ambilDataLokasiUser();
    }
  }, [idLokasi]);

  useEffect(() => {
    if (userLevel || userStatus) {
      ambilDataExpired();
    }
  }, [bulan, userLevel, userStatus, idLokasi]);

  const ambilDataLokasiUser = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.data;
          if (data.length > 0) {
            const fil = data.filter((item) => {
              return idLokasi == item.id;
            });

            if (fil.length > 0) {
              const level = fil[0].level;
              setUserLevel(level);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Gagal mengambil data lokasi user", error);
      });
  };

  const ambilDataExpired = () => {
    setLoading(true);
    let url = "";

    // Tentukan endpoint berdasarkan level user
    if (userStatus == 1 || userLevel === "Dinas") {
      // Level Gudang
      url = `${EXPIRED}gudang?bulan=${bulan}`;
    } else if (userStatus == 2 || userLevel === "Puskesmas") {
      // Level Puskesmas
      url = `${EXPIRED}puskesmas/${idLokasi}?bulan=${bulan}`;
    } else if (userStatus == 3 || userLevel === "Unit") {
      // Level Unit
      url = `${EXPIRED}unit/${idLokasi}?bulan=${bulan}`;
    } else {
      setLoading(false);
      return;
    }

    axios({
      method: "get",
      url: url,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.success === 1) {
            setFirstTable(response.data.data || []);
          } else {
            setFirstTable([]);
            swal(
              "Error",
              response.data.message || "Gagal mengambil data",
              "error"
            );
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error mengambil data expired:", error);
        setFirstTable([]);
        setLoading(false);
        swal("Error", "Gagal mengambil data expired", "error");
      });
  };

  const firstTablePagesCount = Math.ceil(firstTable.length / pageSize);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  const changeBulan = (value) => {
    setBulan(parseInt(value));
    console.log(value);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(firstTable);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data Expired");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      data,
      `Data_Expired_${bulan}_Bulan_${
        new Date().toISOString().split("T")[0]
      }.xlsx`
    );
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Laporan Obat Expired (${bulan} Bulan)`, 14, 15);

    const tableData = firstTable.map((item) => [
      item.nama || "",
      item.sumber || "",
      item.subsumber || "",
      item.tahunPengadaan || "",
      item.harga_satuan ? `Rp. ${numberWithCommas(item.harga_satuan)}` : "-",
      formatTanggalIndonesia(item.tanggal_expired),
      numberWithCommas(item.total_masuk || 0),
      numberWithCommas(item.total_keluar || 0),
      numberWithCommas(item.stok_expired || 0),
      item.harga_stok_expired
        ? `Rp. ${numberWithCommas(item.harga_stok_expired)}`
        : "Rp. 0",
    ]);

    doc.autoTable({
      head: [
        [
          "Nama Obat",
          "Sumber",
          "Sub Sumber",
          "Tahun",
          "Harga Satuan",
          "Tanggal Expired",
          "Total Masuk",
          "Total Keluar",
          "Stok Expired",
          "Harga Stok Expired",
        ],
      ],
      body: tableData,
      startY: 25,
    });

    doc.save(
      `Data_Expired_${bulan}_Bulan_${
        new Date().toISOString().split("T")[0]
      }.pdf`
    );
  };

  return (
    <div>
      <Row>
        <Col>
          <Widget className="widget-p-md">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">
                Laporan Obat yang akan Expired dalam {bulan} bulan de depan
              </h4>
            </div>

            <Row className="mb-3">
              <Col md={3}>
                <FormGroup>
                  <Label>Periode Expired</Label>
                  <Input
                    type="select"
                    value={bulan}
                    onChange={(e) => changeBulan(e.target.value)}
                  >
                    <option value={1}>1 Bulan</option>
                    <option value={3}>3 Bulan</option>
                    <option value={6}>6 Bulan</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3} className="d-flex align-items-end">
                <Button
                  color="primary"
                  onClick={ambilDataExpired}
                  disabled={loading}
                >
                  {loading ? "Memuat..." : "Refresh"}
                </Button>
              </Col>
              <Col
                md={6}
                className="d-flex align-items-end justify-content-end"
              >
                <UncontrolledButtonDropdown>
                  <DropdownToggle caret color="success">
                    Export
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={exportToExcel}>
                      Export Excel
                    </DropdownItem>
                    <DropdownItem onClick={exportToPDF}>
                      Export PDF
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </Col>
            </Row>

            <div className="widget-table-overflow">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "200px" }}
                >
                  <Spinner color="primary" />
                  <span className="ml-3">Memuat data...</span>
                </div>
              ) : (
                <>
                  <Table
                    className={`table-striped table-borderless table-hover ${s.statesTable}`}
                    responsive
                  >
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Nama Obat</th>
                        <th>Sumber</th>
                        <th>Sub Sumber</th>
                        <th>Tahun</th>
                        <th>Harga Satuan</th>
                        <th>Tanggal Expired</th>
                        <th>Total Masuk</th>
                        <th>Total Keluar</th>
                        <th>Stok Expired</th>
                        <th>Harga Stok Expired</th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstTable
                        .slice(
                          firstTableCurrentPage * pageSize,
                          (firstTableCurrentPage + 1) * pageSize
                        )
                        .map((item, index) => (
                          <tr key={uuidv4()}>
                            <td>
                              {firstTableCurrentPage * pageSize + index + 1}
                            </td>
                            <td>{item.nama || "-"}</td>
                            <td>{item.sumber || "-"}</td>
                            <td>{item.subsumber || "-"}</td>
                            <td>{item.tahunPengadaan || "-"}</td>
                            <td>
                              {item.harga_satuan
                                ? `Rp. ${numberWithCommas(item.harga_satuan)}`
                                : "-"}
                            </td>
                            <td>
                              {formatTanggalIndonesia(item.tanggal_expired)}
                            </td>
                            <td>{numberWithCommas(item.total_masuk || 0)}</td>
                            <td>{numberWithCommas(item.total_keluar || 0)}</td>
                            <td>
                              <strong style={{ color: "red" }}>
                                {numberWithCommas(item.stok_expired || 0)}
                              </strong>
                            </td>
                            <td>
                              <strong style={{ color: "red" }}>
                                {item.harga_stok_expired
                                  ? `Rp. ${numberWithCommas(
                                      item.harga_stok_expired
                                    )}`
                                  : "Rp. 0"}
                              </strong>
                            </td>
                          </tr>
                        ))}
                      {firstTable.length === 0 && (
                        <tr>
                          <td colSpan="11" className="text-center">
                            Tidak ada data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <Pagination
                    className="pagination-borderless"
                    aria-label="Page navigation example"
                  >
                    <PaginationItem disabled={firstTableCurrentPage <= 0}>
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage - 1)
                        }
                        previous
                        href="#top"
                      />
                    </PaginationItem>
                    {[...Array(firstTablePagesCount)].map((page, i) => (
                      <PaginationItem
                        active={i === firstTableCurrentPage}
                        key={i}
                      >
                        <PaginationLink
                          onClick={(e) => setFirstTablePage(e, i)}
                          href="#top"
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem
                      disabled={
                        firstTableCurrentPage >= firstTablePagesCount - 1
                      }
                    >
                      <PaginationLink
                        onClick={(e) =>
                          setFirstTablePage(e, firstTableCurrentPage + 1)
                        }
                        next
                        href="#top"
                      />
                    </PaginationItem>
                  </Pagination>
                </>
              )}
            </div>
          </Widget>
        </Col>
      </Row>
    </div>
  );
};

export default TableExpired;
